export default __webpack_public_path__ + "media/images/backgrounds/cta-mud-splat-325d98cbe459ad18007638af91b6a774.svg";